import React, { Fragment } from 'react';

const UncategorizedIcon = '/img/icons/pages-icon.svg';
const FolderIconLink = '/img/icons/folder-icon.svg';

const BeforeIcon = (iconLink = UncategorizedIcon, iconColor = 'd8d8d8') => ({
    alignItems: 'center',
    display: 'flex',

    ':before': {
        content: '" "',
        backgroundImage: `url(${iconLink})`,
        backgroundSize: 20,
        backgroundRepeat: 'no-repeat',
        backgroundColor: `#${iconColor}`,
        borderRadius: '4px',
        display: 'block',
        marginRight: 8,
        height: 20,
        width: 20,
        flex: 'none',
    },
});

const CustomCategoryStyles = {
    option: (styles, { data }) => ({ ...styles, ...BeforeIcon(data.icon, data.color) }),
    input: styles => ({ ...styles, ...BeforeIcon() }),
    placeholder: styles => ({ ...styles, ...BeforeIcon() }),
    singleValue: (styles, { data }) => ({ ...styles, ...BeforeIcon(data.icon, data.color) }),
};

const CustomFolderStyles = {
    option: (styles, { data }) => ({ ...styles, ...BeforeIcon(data.icon, data.color) }),
    input: styles => ({ ...styles, ...BeforeIcon(FolderIconLink) }),
    placeholder: styles => ({ ...styles, ...BeforeIcon(FolderIconLink) }),
    singleValue: (styles, { data }) => ({ ...styles, ...BeforeIcon(data.icon, data.color) }),
};

const Separator = () => (<span className="ml1 mr1 silver">/</span>);
const EllipsisSeparator = () => (
    <span className="silver">
        <span className="ml1 mr1">/</span>
        <span className="ml1 mr1">...</span>
        <span className="ml1 mr1">/</span>
    </span>
);

const FolderIcon = ({
    icon = '/img/icons/folder-icon.svg', color = 'd8d8d8', className = 'mr1 rounded left', size = 20,
}) => (
    <img className={className} height={size} width={size} src={icon} style={{ backgroundColor: `#${color}` }} />
);

const CategoryIcon = ({
    icon = '/img/icons/category-icon.svg', color = 'd8d8d8', className = 'mr1 rounded left', size = 20,
}) => <img className={className} height={size} width={size} src={icon} style={{ backgroundColor: `#${color}` }} />;

const CategoryFolderTitle = (props) => {
    const {
        categoryName,
        categoryIcon,
        categoryColor,
        folderName,
        folderIcon,
        folderColor,
        isNested = false,
        defaultText,
    } = props;

    if (categoryName && folderName) {
        return (
            <Fragment>
                <span className="elipsis" style={{ lineHeight: '20px' }}>
                    <CategoryIcon icon={categoryIcon} color={categoryColor} />
                    {categoryName}
                </span>
                {isNested
                    ? <EllipsisSeparator />
                    : <Separator />}
                <span className="elipsis" style={{ lineHeight: '20px' }}>
                    <FolderIcon icon={folderIcon} color={folderColor} />
                    {folderName}
                </span>
            </Fragment>
        );
    } if (categoryName) {
        return (
            <span className="elipsis" style={{ lineHeight: '20px' }}>
                <CategoryIcon icon={categoryIcon} color={categoryColor} />
                {categoryName}
            </span>
        );
    }

    return (<Fragment>{defaultText}</Fragment>);
};

export {
    CategoryIcon,
    FolderIcon,
    CustomCategoryStyles,
    CustomFolderStyles,
    BeforeIcon,
};

export default CategoryFolderTitle;
